export interface SidebarCategory {
    name?: string;
    showCategoryDots: boolean;
    items: (SidebarCategoryItem | SidebarCategoryDropdownItem)[];
}

export interface SidebarCategoryItem {
    name: string;
    icon: string;
    path: string;
    clickCallback?: () => void | null;
}

export interface SidebarCategoryDropdownItem {
    name: string;
    icon: string;
    items: SidebarCategoryItem[];
    clickCallback?: () => void | null;
}

export function createSidebarCategoryItem(
    name: string,
    icon: string,
    path: string,
    clickCallback: (() => void) | null = null
): SidebarCategoryItem {
    return {
        name,
        icon,
        path,
        clickCallback,
    };
}

export function createSidebarCategoryDropdownItem(
    name: string,
    icon: string,
    items: SidebarCategoryItem[],
    clickCallback: (() => void) | null = null
): SidebarCategoryDropdownItem {
    return {
        name,
        icon,
        items,
        clickCallback,
    };
}
